var map = {
	"./am.json": [
		"./translations/am.json",
		"translations_am_json"
	],
	"./en.json": [
		"./translations/en.json",
		"translations_en_json"
	],
	"./es.json": [
		"./translations/es.json",
		"translations_es_json"
	],
	"./fr.json": [
		"./translations/fr.json",
		"translations_fr_json"
	],
	"./he.json": [
		"./translations/he.json",
		"translations_he_json"
	],
	"./km.json": [
		"./translations/km.json",
		"translations_km_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./translations lazy .json$";
module.exports = webpackAsyncContext;